import Enum from "./enum";

export default class Role extends Enum {
    static get translationKey (): string {
        return 'roles'
    }

    static MosqueAdmin = "mosque-admin";
    static MosqueMember = "mosque-member";
}